const giftya_base_url = window.react_giftya_base_url;
const merchant_partner_names = {
    access_development: 'access-development',
};
const pick_path = 'M0 132 C 0 88, 300 -140, 300 132 C 300 405, 0 177, 0 132';
const shadow_pick_path = 'M0 131 C 0 86, 300 -145, 300 131 C 300 401, 0 183, 0 131';
const pick_view_box = '0 0 300 264';

export {giftya_base_url, merchant_partner_names, pick_path, pick_view_box, shadow_pick_path};
